import {
  Product,
  ProductListGroupId,
  Section,
} from "@ubnt/store.core/lib/constants/modelCompareData/types";

export const createBaseCompareState = (
  section: Section,
  defaultSelectedProductCount: number = 3,
  groupId?: ProductListGroupId,
) => {
  if (!section) {
    return [];
  }

  const { products } = section;

  if (groupId) {
    const groupProductsOnly = products.filter(
      ({ productListGroup }) => productListGroup?.id === groupId,
    );

    return getPreselectedProducts(
      groupProductsOnly,
      defaultSelectedProductCount,
    );
  }

  return getPreselectedProducts(products, defaultSelectedProductCount);
};

const getPreselectedProducts = (
  products: Product[],
  defaultSelectedProductCount: number,
) => {
  const list = products.slice(0, defaultSelectedProductCount);

  return list.map(mapToProductData);
};

const mapToProductData = (product: Product) => ({
  productId: product?.id,
  groupId: product?.productListGroup?.id ?? null,
});
